import { render, staticRenderFns } from "./OrganizationList.vue?vue&type=template&id=b73e4baa&"
import script from "./OrganizationList.vue?vue&type=script&lang=js&"
export * from "./OrganizationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b73e4baa')) {
      api.createRecord('b73e4baa', component.options)
    } else {
      api.reload('b73e4baa', component.options)
    }
    module.hot.accept("./OrganizationList.vue?vue&type=template&id=b73e4baa&", function () {
      api.rerender('b73e4baa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/organizations/OrganizationList.vue"
export default component.exports